"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useReliabilityDetailsInformation = void 0;
var React = _interopRequireWildcard(require("react"));
var _reliability = require("../services/reliability");
var _context = require("../shared/context");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useReliabilityDetailsInformation = _ref => {
  let {
    newbuildingId,
    houseId
  } = _ref;
  const {
    httpApi,
    logger
  } = React.useContext(_context.NewbuildingReliabilityContext);
  const [isLoading, setIsLoading] = React.useState(true);
  const [reliabilityDetails, setReliabilityDetails] = React.useState(null);
  const loadReliabilityDetails = React.useCallback(params => {
    setIsLoading(true);
    (0, _reliability.fetchReliability)({
      params,
      httpApi,
      logger
    }).then(reliability => {
      if (!reliability) {
        setIsLoading(false);
        setReliabilityDetails(null);
        return;
      }
      setReliabilityDetails(reliability);
      setIsLoading(false);
    });
  }, []);
  React.useLayoutEffect(() => {
    loadReliabilityDetails({
      newbuildingId,
      houseId
    });
  }, [newbuildingId, houseId]);
  return {
    reliabilityDetails,
    isLoading,
    loadReliabilityDetails
  };
};
exports.useReliabilityDetailsInformation = useReliabilityDetailsInformation;